"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const DOWN_OPTION_LEFTHIP = "left hip";
const LEFTTWIST = "left twist";
const LEFTKNEE = "left knee";
const RIGHTHIP = "right hip";
const RIGHTTWIST = "right twist";
const RIGHTKNEE = "right knee";
const LEFTARM = "left arm";
const RIGHTARM = "right arm";
const EYES = "eyes";
const SERVO_NAMES_MAP = [DOWN_OPTION_LEFTHIP, LEFTTWIST, LEFTKNEE, RIGHTHIP, RIGHTTWIST, RIGHTKNEE, LEFTARM, RIGHTARM, EYES];
var _default = exports.default = SERVO_NAMES_MAP;